import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["backgroundImageUrl", "backgroundPosition", "backgroundRepeat", "backgroundSize", "className", "children", "isOverlapped", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { enhancedConnect } from "../../utils";
import styles from "./styles.pcss";
import { Content } from "./Content";
var cx = classNames.bind(styles);
var _SharedBlock = function _SharedBlock(_ref) {
  var backgroundImageUrl = _ref.backgroundImageUrl,
    backgroundPosition = _ref.backgroundPosition,
    backgroundRepeat = _ref.backgroundRepeat,
    backgroundSize = _ref.backgroundSize,
    className = _ref.className,
    children = _ref.children,
    isOverlapped = _ref.isOverlapped,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("section", {
    className: cx('section', isOverlapped && 'isOverlapped', className),
    style: isMobile ? _objectSpread({
      backgroundSize: backgroundSize,
      backgroundPosition: backgroundPosition,
      backgroundRepeat: backgroundRepeat,
      backgroundImage: "url(".concat(backgroundImageUrl, ")")
    }, style) : style,
    "data-t-id": "components-SharedBlock"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('container', isOverlapped && 'isOverlapped')
  }, /*#__PURE__*/React.createElement(Content, props), children));
};
export var SharedBlock = enhancedConnect({
  backgroundImageUrl: PropTypes.string,
  backgroundPosition: PropTypes.string,
  backgroundSize: PropTypes.string,
  backgroundRepeat: PropTypes.string,
  isOverlapped: PropTypes.bool,
  children: PropTypes.node,
  name: PropTypes.string,
  label: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  iconSrc: PropTypes.string,
  style: PropTypes.object
})(_SharedBlock);